<template>
    <a-tooltip v-if="tooltipKey || tooltip" overlayClassName="tooltip" color="var(--box-nested-white-xl-max)">
        <template #title>
            <span>{{ tooltipText }}</span>
        </template>
        <svg v-bind="$attrs" class="icon-svg tool" aria-hidden="true" :width="size" :height="size" :style="iconStyle">
            <use :href="`#${name}`"></use>
        </svg>
    </a-tooltip>

    <svg v-else v-bind="$attrs" class="icon-svg no-tool" aria-hidden="true" :width="size" :height="size" :style="iconStyle">
        <use :href="`#${name}`"></use>
    </svg>
</template>

<script setup>
import { computed, onMounted } from 'vue'
import { useI18n } from 'vue-i18n'  //如果使用国际化
import { loadIcons } from '@/assets/icons/sprite'

defineOptions({ inheritAttrs: false })

const { t } = useI18n()

onMounted(() => {
    loadIcons()
})

const props = defineProps({
    name: {
        type: String,
        required: true
    },
    size: {
        type: [Number, String],
        default: 19.25925925925926
    },
    color: {
        type: String,
        default: 'currentcolor'
    },
    tooltip: {
        type: String,
        default: ''
    },
    tooltipKey: {  // 国际化键名
        type: String,
        default: ''
    }
})

const iconStyle = computed(() => ({
    fill: props.color,
    minWidth: `${props.size}px`
}))

const tooltipText = computed(() => {
    if (props.tooltipKey) {
        return t(`keyBindings.${props.tooltipKey}`)
    }
    return props.tooltip
})
</script>
<style scoped lang="scss">
.tool {
    position: relative;
    z-index: 10;
}

.tooltip {
    background-color: var(--box-nested-white-xl-max);
    color: var(--text-black-l-title);
}
</style>
